import React from "react";
import { Segment } from "semantic-ui-react";
import routeConfig from "../../../../modules/routeConfig";
import PKOReport from "./pages/PKOReport";

const routes = [
  {
    path: "/pko",
    component: PKOReport,
  },
  {
    path: "",
    component: () => (
      <Segment basic padded="very" style={{ padding: "2em" }}>
        <h2>Reports</h2>
        <p>Select a report type from the menu on the left.</p>
      </Segment>
    ),
  },
];

export default routeConfig(routes);
